(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{rootMargin:'-60px'});
  document.querySelectorAll('[data-reveal]').forEach(function(el){io.observe(el);});
  var b=document.querySelector('[data-burger]'),n=document.querySelector('[data-mobile-nav]');
  if(b&&n)b.addEventListener('click',function(){n.hidden=!n.hidden;});
})();
/* hero slider */
(function(){
  document.querySelectorAll('[data-hslider]').forEach(function(root){
    var track=root.querySelector('[data-htrack]');
    if(!track)return;
    var slides=track.children, total=slides.length;
    if(total<2)return;
    var dotsWrap=root.querySelector('[data-hdots]'), i=0, timer;
    var dots=[];
    if(dotsWrap){
      for(var k=0;k<total;k++){
        var d=document.createElement('button');
        d.setAttribute('aria-label','Slide '+(k+1));
        (function(x){d.addEventListener('click',function(){go(x);reset();});})(k);
        dotsWrap.appendChild(d); dots.push(d);
      }
    }
    function go(x){
      i=(x+total)%total;
      track.style.transform='translateX(-'+(i*100)+'%)';
      dots.forEach(function(d,j){d.className=j===i?'on':'';});
    }
    function reset(){clearInterval(timer);timer=setInterval(function(){go(i+1);},5500);}
    var p=root.querySelector('[data-hprev]'), nx=root.querySelector('[data-hnext]');
    if(p)p.addEventListener('click',function(){go(i-1);reset();});
    if(nx)nx.addEventListener('click',function(){go(i+1);reset();});
    go(0); reset();
  });
})();
/* count-up stats */
(function(){
  document.querySelectorAll('.count').forEach(function(el){
    var target=parseInt(el.getAttribute('data-count'),10)||0, suffix=el.getAttribute('data-suffix')||'';
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){
      var dur=1500, t0=null;
      function tick(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/dur);var eased=1-Math.pow(1-p,3);el.textContent=Math.round(eased*target)+suffix;if(p<1)requestAnimationFrame(tick);}
      requestAnimationFrame(tick); io.unobserve(el);
    }})},{rootMargin:'-40px'});
    io.observe(el);
  });
})();
/* quick add to cart (AJAX, progressive enhancement) */
(function(){
  document.querySelectorAll('form[data-quickadd]').forEach(function(f){
    f.addEventListener('submit',function(e){
      if(!window.fetch)return; // fall back to native POST
      e.preventDefault();
      var btn=f.querySelector('.bag'), id=f.querySelector('input[name=id]').value;
      if(btn.classList.contains('busy'))return; btn.classList.add('busy');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
        .then(function(r){if(!r.ok)throw r;return r.json();})
        .then(function(){
          btn.classList.add('added');
          fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
            var el=document.querySelector('[data-cart-count]'); if(el){el.textContent=c.item_count;el.hidden=c.item_count<1;}
          });
          setTimeout(function(){btn.classList.remove('added');btn.classList.remove('busy');},1500);
        })
        .catch(function(){btn.classList.remove('busy');f.submit();});
    });
  });
})();
